import ComponentHelper from '../../supers/ComponentHelper';
import AuthService from '../../services/AuthService';
import RESTService from '../../services/RESTService';
import queryString from 'query-string';
import InputField from '../../components/input-field/InputField';
import React from 'react';
import bgImg from './Portal_BG_v1.jpg';
import './login.css';
import ValidationService from '../../services/ValidationService';

const connect = new RESTService();
const auth = new AuthService();

class Login extends ComponentHelper {
	constructor(props) {
		super(props);
		// Get URL query string paramenters set by e-mail links.
		const queryData = queryString.parse(this.props.location.search);

		// Get remembered user from Local Storage.
		const rememberedUser = window.localStorage.getItem('rememberedUser') || '';

		this.initialState = {
			step: this.getInitialStep(queryData),
			rememberme: !!rememberedUser, // default to checked if already remembering a user
			username: queryData.email || rememberedUser,
			password: '',
			sessionId: queryData.sessionId || '',
			passwordResetToken: queryData.passwordResetToken || '',
			code: queryData.code || '',
			status: 'init',
			error: null,
			newPass: '',
			newPassAgain: '',
			newPassValidation: {
				validLength: false,
				containsNumber: false,
				containsLowercase: false,
				containsUppercase: false
			}
		};
		this.state = this.initialState;
	}

	// If the URL contains a sessionId and code parameters (probably set by a "magic link" e-mail) attempt a login
	componentDidMount() {
		const { code } = queryString.parse(this.props.location.search);
		if (code) this.executeLogin(code);
	}

	// Determine the login initial step based on the URL parameters
	getInitialStep = ({ passwordResetToken, sessionId, email, code }) => {
		return passwordResetToken && email ? 'input-new-pass' : sessionId && code ? 'input-code' : 'input-username';
	};

	handleFormChange = e => {
		const { name, value } = e.target;

		this.setState(state => ({
			[name]: value,
			newPassValidation: name === 'newPass' ? this.validatePass(value) : state.newPassValidation
		}));
	};

	handleToggle = e => this.setState({ rememberme: e.target.checked });

	handleForgotPassClick = () => {
		const { username } = this.state;
		this.setState({ status: 'pending', error: null }, () => {
			connect
				.password(username)
				.then(({ data }) => this.setState({ status: 'init', step: 'recover-pass-email-sent' }))
				.catch(({ message }) => this.setState({ status: 'failure', error: message }));
		});
	};

	handleSendMagicLinkClick = () => {
		const { username } = this.state;
		this.setState({ status: 'pending', error: null }, () => {
			connect
				.login(username, null, 'magic-link')
				.then(() => {
					this.setState({ status: 'init', step: 'magic-link-sent' });
				})
				.catch(({ message }) => this.setState({ status: 'failure', error: message }));
		});
	};

	handleBackClick = () => this.setState(this.initialState);

	handleSubmit = e => {
		e.preventDefault();
		const { username, password, rememberme, newPass, code, passwordResetToken, step } = this.state;

		if (step === 'input-username' && this.validateEmail()) {
			if (rememberme) {
				window.localStorage.setItem('rememberedUser', username);
			} else {
				window.localStorage.removeItem('rememberedUser');
			}
			this.setState({ step: 'input-password' });
		}

		if (step === 'input-password' && this.validatePassword()) {
			this.setState({ status: 'pending', error: null }, () => {
				connect
					.login(username, password, 'user-credentials')
					.then(({ data }) => this.setState({ status: 'init', step: 'input-code', sessionId: data.sessionId }))
					.catch(({ message }) => this.setState({ status: 'failure', error: message }));
			});
		}

		if (step === 'input-new-pass' && this.validateRecoverPassword()) {
			this.setState({ status: 'pending', error: null }, () => {
				connect
					.password(username, newPass, passwordResetToken)
					.then(({ data }) => this.setState({ status: 'success' }))
					.then(() => this.props.history.push((this.props.location.state && this.props.location.state.from) || '/'))
					.catch(({ message }) => this.setState({ status: 'failure', error: message }));
			});
		}

		if (step === 'input-code' && this.validateCode()) {
			this.setState({ status: 'pending', error: null }, () => this.executeLogin(code));
		}
	};

	executeLogin = code => {
		connect
			.getToken(code)
			.then(res => {
				if (res.data.token) {
					auth.storeAccessToken(res.data.token);
				}
			})
			.then(() => {
				if (auth.token) {
					this.props.history.push((this.props.location.state && this.props.location.state.from) || '/');
				}
			})
			.catch(err => {
				//TODO's use the new error object
				console.log(err);
				this.setState({ status: 'failure', error: err.response.data });
			});
	};

	validateEmail = () => {
		return new ValidationService().validateEmail(this.state.username);
	};

	validatePassword = () => {
		return !!this.state.password;
	};

	validateRecoverPassword = () => {
		const { newPass, newPassAgain, newPassValidation } = this.state;
		let isValid = true;
		if (newPass) {
			if (Object.values(newPassValidation).filter(v => !v).length > 0) {
				isValid = false;
			} else {
				if (newPassAgain && newPass !== newPassAgain) {
					isValid = false;
				}
			}
		} else {
			isValid = false;
		}
		if (!newPassAgain) {
			isValid = false;
		}
		return isValid;
	};

	validateCode = () => {
		return !!this.state.code;
	};

	validatePass = value => ({
		validLength: value.length >= 8,
		containsNumber: !!value.match(/[0-9]/),
		containsLowercase: !!value.match(/[a-z]/),
		containsUppercase: !!value.match(/[A-Z]/)
	});

	render() {
		const { step, username, rememberme, code, newPass, newPassAgain, newPassValidation, status, error } = this.state;

		return (
			<div className="login animated fadeIn hbox vfit">
				<img src={bgImg} className="portal-img" alt="Login" />
				<div className="form-cnt grow-1 vbox vhcenter">
					<form className="form vbox vcenter hcenter" onSubmit={this.handleSubmit}>
						<div className="logo" title="Mad Cloud">
							<i className="mdi mdi-cloud-outline" />
							<div className="letter">m</div>
						</div>
						{step === 'input-username' && (
							<div>
								<h1>Login</h1>
								<InputField
									handleChange={this.handleFormChange}
									name="username"
									label="E-mail"
									type="text"
									required
									autoFocus={true}
									value={username}
								/>
								<label htmlFor="rememberme" className="rememberme">
									<span>Remember me</span>
									<input type="checkbox" checked={rememberme} onChange={this.handleToggle} />
								</label>
								{status === 'failure' && <p className="error-msg">Error: {error}</p>}
								<button className="btn primary" type="submit" disabled={!this.validateEmail() || status === 'pending'}>
									{status === 'pending' ? 'Sending...' : 'Submit'}
								</button>
							</div>
						)}
						{step === 'input-password' && (
							<div>
								{/*<InputField*/}
								{/*handleChange={this.handleFormChange}*/}
								{/*name="password"*/}
								{/*label="Password"*/}
								{/*type="password"*/}
								{/*required*/}
								{/*autoFocus={true}*/}
								{/*value={password}*/}
								{/*/>*/}
								{/*<button className="btn no-border" type="button" onClick={this.handleForgotPassClick}>*/}
								{/*Forgot your password?*/}
								{/*</button>*/}
								{status === 'failure' && <p className="error-msg">Error: {error}</p>}
								{/*<button className="btn primary" type="submit" disabled={!this.validatePassword() || status === 'pending'}>*/}
								{/*{status === 'pending' ? 'Sending...' : 'Submit'}*/}
								{/*</button>*/}
								{/*<p className="txt">or</p>*/}
								<button className="btn" type="button" onClick={this.handleSendMagicLinkClick}>
									Email quick link
								</button>
							</div>
						)}
						{step === 'recover-pass-email-sent' && (
							<div>
								<h1>A Password Reset email is on its way!</h1>
								<p className="txt">
									Thanks! If there's an account associated with this email, we'll send the password reset instructions immediately.
								</p>
								<button className="btn go-back" type="button" onClick={this.handleBackClick}>
									Go back
								</button>
							</div>
						)}

						{step === 'input-new-pass' && (
							<div>
								<h1>Reset password</h1>
								<InputField
									handleChange={this.handleFormChange}
									name="newPass"
									label="New password"
									type="password"
									required
									autoFocus={true}
									value={newPass}
								/>
								<ul className="pass-validations">
									<li data-valid={newPassValidation.validLength}>Is 8 characters or longer</li>
									<li data-valid={newPassValidation.containsNumber}>Contains 1 number</li>
									<li data-valid={newPassValidation.containsLowercase}>Contains 1 lowercase letter</li>
									<li data-valid={newPassValidation.containsUppercase}>Contains 1 uppercase letter</li>
								</ul>
								<InputField
									handleChange={this.handleFormChange}
									name="newPassAgain"
									label="Re-type password"
									type="password"
									required
									value={newPassAgain}
								/>
								{status === 'failure' && <p className="error-msg">Error: {error}</p>}
								<button className="btn primary" type="submit" disabled={!this.validateRecoverPassword() || status === 'pending'}>
									{status === 'pending' ? 'Sending...' : 'Submit'}
								</button>
							</div>
						)}
						{step === 'magic-link-sent' && (
							<div>
								<h1>An authorization email is on its way!</h1>
								<p className="txt">
									If there's an account associated with this email, you'll find a passwordless authentication link that will sign you in. The link
									expires in 5 minutes, so be sure to check your email soon.
								</p>
								<button className="btn go-back" type="button" onClick={this.handleBackClick}>
									Go back
								</button>
							</div>
						)}
						{step === 'input-code' && (
							<div>
								<h1>Verify your identity</h1>
								<InputField handleChange={this.handleFormChange} name="code" label="Code" type="string" required autoFocus={true} value={code} />
								{status === 'failure' && <p className="error-msg">Error: {error}</p>}
								<button className="btn primary" type="submit" disabled={!this.validateCode() || status === 'pending'}>
									{status === 'pending' ? 'Sending...' : 'Submit'}
								</button>
								<button className="btn go-back" type="button" onClick={this.handleBackClick}>
									Go back
								</button>
							</div>
						)}
					</form>
				</div>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/login/Login.js